const Title = ({ label, labelClassName, className }) => (
  <div className={className}>
    <h4 className={labelClassName}>{label}</h4>
  </div>
);

export default Title;
